import marketListItemV2 from '@/components/market/v2/market-list-item-v2/market-list-item-v2.vue';

export default {
  props: {
    markets: {
      type: Array,
      required: true,
    },
  },
  components: {
    marketListItem: marketListItemV2,
  },
};



// WEBPACK FOOTER //
// ./src/components/cms/market-list-item-v2-embed/market-list-item-v2-embed.js